import { createFileRoute } from '@tanstack/react-router';

import { AgentAutomationGroupDetailPage } from '@apps/web/components/automations/automation_surface';

export const Route = createFileRoute(
    '/_app/admin/agent/automations/groups/$automationGroupId',
)({
    component: AdminAutomationGroupDetailRoute,
});

function AdminAutomationGroupDetailRoute() {
    const { automationGroupId } = Route.useParams();
    return (
        <AgentAutomationGroupDetailPage automationGroupId={automationGroupId} />
    );
}
